import React from 'react'
import { ChevronRight } from 'lucide-react'

// ─────────────────────────────────────────────────────────────────────────────
//   El texto largo del backend, disponible pero no impreso
//
//   Casi todos los bloques de `/corporate/overview` traen un `detail`: un
//   párrafo del propio endpoint que explica por qué una cifra significa lo que
//   significa. Se pintaban todos, siempre, y entre unos y otros la pantalla
//   quedó con más prosa que cifras — los párrafos tapaban justo lo que venían a
//   explicar.
//
//   La regla es una línea por bloque. Esa línea la escribe la pantalla porque
//   es rótulo, no regla; el párrafo entero sigue siendo el del backend y sigue
//   estando, un clic más allá.
//
//   `<details>` nativo y no un estado de React: el contenido está en el DOM
//   plegado, así que el Ctrl+F del navegador lo encuentra y lo despliega solo,
//   funciona sin JS, y el teclado lo abre sin que haya que cablear nada. Un
//   tooltip haría lo contrario — invisible en móvil, invisible al imprimir e
//   invisible para quien no sabe que hay algo que mirar.
//
//   El `detail` va SIEMPRE literal y nunca reescrito aquí. Es la lección que
//   deja `net_position`: la pantalla llevaba a mano "less the bank debt still
//   owed", el backend dejó de restar la deuda, y el texto se quedó mintiendo
//   sobre una cifra correcta. Una frase escrita en el cliente sobre una regla
//   que vive en el servidor no se desincroniza algún día: se desincroniza y
//   nadie se entera.
// ─────────────────────────────────────────────────────────────────────────────

export default function DetailNote({ summary, detail, style }) {
  // Sin `detail` no hay nada que desplegar, y un resumen que abre en vacío es
  // peor que ningún resumen.
  if (!detail) return null

  return (
    <details className="cf-note" style={style}>
      <summary>
        <ChevronRight className="cf-note-chevron" size={13} />
        <span>{summary}</span>
      </summary>
      <p className="cf-note-body">{detail}</p>
    </details>
  )
}
